import { onMounted, onUnmounted } from 'vue'
import useAuth from '@/composables/useAuth'
import { useRouter } from '@/utils/index'

// Increased to 2 hours to better align with Firebase token lifetime
const INACTIVITY_LIMIT = 20 * 60 * 60 * 1000 // 20 hours

export default function useAutoLogout() {
  let timer = null
  const { logout, state: authState } = useAuth()
  const { router } = useRouter()

  const resetTimer = () => {
    // Only set timer if user is logged in
    if (!authState.user) return

    clearTimeout(timer)
    timer = setTimeout(async () => {
      console.log('Auto-logout due to inactivity')
      await logout()
      if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login' })
      }
    }, INACTIVITY_LIMIT)
  }

  // Include more activity events and API activity
  const activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click']

  // Also reset timer on API activity
  const handleApiActivity = () => {
    resetTimer()
  }

  // Listen for custom API activity event
  if (typeof window !== 'undefined') {
    window.addEventListener('api-activity', handleApiActivity)
  }

  onMounted(() => {
    activityEvents.forEach(event => window.addEventListener(event, resetTimer))
    resetTimer()
  })

  onUnmounted(() => {
    activityEvents.forEach(event => window.removeEventListener(event, resetTimer))
    if (typeof window !== 'undefined') {
      window.removeEventListener('api-activity', handleApiActivity)
    }
    clearTimeout(timer)
  })
}
